import React, { useState } from "react";
import { useHistory } from "react-router-dom";



const AddInstructor = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isPending, setIsPending] = useState(false);

  const role = "Instructor";
  const password = "123";

  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    const blog = {
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      role,
    };

    setIsPending(true);

    fetch(`${process.env.REACT_APP_BASE_URL}/admin/user`, {
      method: "POST",
      body: JSON.stringify(blog),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then((data) => data.json())
      .then((res) => {
        setIsPending(false);
        history.push("/dashboard");
      });
  };
  return (
    <div className="add-page mt-3">
      <div className="container">
        <div className="row">
          <div className="col-12 m-auto">
            <div className="mb-3">
              <h3>Add Instructor</h3>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="datails-content">
                <label>First Name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>

              <div className="datails-content">
                <label>Last Name</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div className="datails-content">
                <label>E-mail</label>
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              {/* <div className="datails-content">
                <label>Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div> */}

              <button className="contButSmall">
                {isPending ? "Loading..." : "save"}{" "}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddInstructor;
